<template>
	<div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="p-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<div class="px-4 bg-grey-custom pb-4">
      		<wrapper-mobile-view>
						<div class="w-100 py-3 px-4" :class="{'bg-white border-b-semi-grey':scrollPosition > 30}">
							<div class="w-100">
								<div class="row">
									<div class="col-1 align-self-center">
										<div @click="backTo()" class="d-inline-grid cursor-pointer">
	                    <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
	                  </div>
									</div>
									<div class="col-9 align-self-center">
										<p class="mb-0 body-1-2">{{$t('hotel.concierge.membership')}}</p>
									</div>
								</div>
							</div>
						</div>
					</wrapper-mobile-view>
					<block :height="45" />
					<div class="">
						<MemberCard :data="data.card" :guest_name="guest_name"></MemberCard>
					</div>
				</div>
					<!-- <div class="py-3 mt-3" v-if="data.card.benefit.length > 0">
			      <div class="pb-3">
			        <div class="row no-gutters">
			          <div class="col-12 col-md-12">
			            <p class="mb-0 font-bold text-20 body-2-2">{{$t('hotel.concierge.the-benefit-of-being')}} {{data.card.card_name}}</p>
			          </div>
			        </div>
			      </div>
			      <div class="pt-3 border-top">
			        <div class="">
			          <div class="row slim-grid-row mb-2" v-for="benefit in data.card.benefit">
			            <div class="col-1">
			              <img src="../../../assets/img/icon/correct.png" class="position-relative" width="13" style="top: -2px">
			            </div>
			            <div class="col-11">
			              <p class="mb-0 body-2-2 font-semibold text-14">{{benefit}}</p>
			            </div>
			          </div>
			        </div>
			    	</div>
			    </div> -->
			    <div class="py-4 w-100">
			      <div id="Voucher" class="position-relative" style="top: -115px"></div>
			      <div class="px-4">
				      <p class="sub-heading-1-1 mb-1">{{$t('hotel.concierge.reward')}}</p>
				      <p class="body-2-2-1 sub-title mb-0">{{$t('hotel.concierge.contact-staff-to-claim-reward')}}</p>
						</div>
			      <!-- CATEGORY -->
		        <div class="pl-4 position-sticky pt-3 mb-1 pb-2 bg-white z-index-1038" style="top:48px"  :class="{'border-b-semi-grey':scrollPosition > 340}">
		          <flickity ref="flickity" class="flickity-category" :options="slider_option.category">
		            <div v-for="data in category" class="carousel-cell-category" @click="category_id = data.id" style="width: max-content;">
		             <p class="body-3 text-13 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer bg-light-page radius-6" :class="{'font-bold delay bg-green text-white border-green':data.id == category_id }">{{data.name}}</p>
		            </div>
		          </flickity>
		        </div>
		        <div class="px-4">
				      <div class="w-100 mb-4 rounded-6 bg-white border cursor-pointer" v-for="reward in data.reward" :class="{'d-none':reward.type=='HOTEL_PROMOTION' && category_id != 'hotel' && category_id != 'all' || reward.type=='CONCIERGE_PROMOTION' && category_id != 'concierge' && category_id != 'all' || reward.type=='NONE' && category_id != 'other' && category_id != 'all'}" @click="detailReward(reward)">
		            <div class="w-100">
		              <img :src="reward.image_url" class="w-100 rounded-top-6 object-fit h-slide-reward cursor-pointer">
		              <div class="py-3 px-3">
		                <p class="mb-1 body-2-2 font-bold text-truncate text-16 cursor-pointer">{{reward.name}}</p>
		                <p class="mb-1 body-2 text-14 font-semibold d-inline-block" v-if="reward.end_date != null">{{$t('hotel.concierge.valid-until')}} {{$formatDate(reward.end_date)}}</p>
		                <p class="mb-0 body-2 font-semibold text-15 cursor-pointer" v-if="reward.type == 'HOTEL_PROMOTION'">{{$t('hotel.concierge.fitur.hotel-reward')}}</p>
		                <p class="mb-0 body-2 font-semibold text-15 cursor-pointer" v-if="reward.type == 'CONCIERGE_PROMOTION'">{{$t('hotel.concierge.fitur.concierge-reward')}}</p>
		                <p class="mb-0 body-2 font-semibold text-15 cursor-pointer" v-if="reward.type == 'NONE'">{{$t('hotel.concierge.fitur.other-reward')}}</p>
		                <p class="mb-0 body-2-2 font-regular text-13 mt-2 text-truncate-2 cursor-pointer">{{reward.description}}</p>
		              </div>
		            </div>
		          </div> 
		        </div>
			    </div>
			</template>
		</template>

		<!-- DETAIL -->
    <popup-detail 
    	direction="bottom" 
    	:show="detail.show"
    	wrapper_size="mobile"
    	use_max_size
    	@close="detailReward">
    	<template v-slot:body>
    		<div class="">
    			<div class="w-100 position-relative">
    				<div style="height:250px;">
		        	<img :alt="detail.name" :src="detail.image_url" class="img-fit rounded-top-12" />
		        </div>
		        <div class="bg-white m-2 rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="closeDetail()">
							<img alt="close-icon" src="../../../assets/img/icon/close.png" width="14" />
						</div>
    			</div>
    			<div class="p-4">
	        	<p class="mb-1 body-1-2 font-semibold text-18">{{detail.name}}</p>
	        	<p class="mb-0 body-2 font-semibold text-15" v-if="detail.type == 'HOTEL_PROMOTION'">{{$t('hotel.concierge.fitur.hotel-reward')}}</p>
            <p class="mb-0 body-2 font-semibold text-15" v-if="detail.type == 'CONCIERGE_PROMOTION'">{{$t('hotel.concierge.fitur.concierge-reward')}}</p>
            <p class="mb-0 body-2 font-semibold text-15" v-if="detail.type == 'NONE'">{{$t('hotel.concierge.fitur.other-reward')}}</p>
            <p class="mb-1 body-2 text-14 font-semibold d-inline-block" v-if="detail.end_date != null">{{$t('hotel.concierge.valid-until')}} {{$formatDate(detail.end_date)}}</p>
		        <p class="mb-3 body-2-2 font-regular text-14 mt-2">{{detail.description}}</p>
		        <!-- Module -->
		        <p class="mb-2 body-2-2 text-semi-dark font-bold text-16" v-if="detail.module != ''">{{$t('hotel.concierge.claim-your-reward')}}</p>
		        <div class="p-3 mb-3 border-semi-grey radius-6 w-100" v-for="(data,index) in detail.module" :class="{'d-block':data.code==validation.room_dinning ||data.code==validation.experience || data.code==validation.spa || data.code==validation.laundry }" style="display:none">
		        	<div class="row">
		        		<div class="col-8 align-self-center">
	        				<p class="mb-0 body-2-2 font-bold text-dark text-15">{{data.name}}</p>
		        		</div>
		        		<div class="col-4 align-self-center">
		        			<button type="button" class="g-btn g-btn-primary g-btn-md w-100" @click="moduleClaim(data.code)">{{$t('hotel.action.claim')}}</button>
		        		</div>
		        	</div>
		        </div>
        	</div>
					<template v-if="detail.type == 'HOTEL_PROMOTION'">
						<block :height="60" />
	        	<div class="w-100">
				    	<wrapper-mobile-view fixed_position="bottom">
								<div class="px-4 pt-3 pb-4">
						      <button type="button" @click="routeReward(detail.type)" class="ga-btn-primary ga-btn-primary-lg">{{$t('hotel.concierge.claim-your-reward')}}</button>
						    </div>
						  </wrapper-mobile-view>
				    </div>
					</template>
    		</div>
	    </template>
    </popup-detail>

	</div>
</template>
<script>
	import MemberCard from '@/components/hotel/concierge/member/MemberCard'
	import RewardList from '@/components/hotel/concierge/member/RewardList'
  import {mapGetters,mapMutations} from "vuex";
  import {get} from '@/services/index.js'
  import RewardDetail from '@/components/hotel/concierge/member/RewardDetail'
  import Flickity from 'vue-flickity';

	export default{
		components:{
			MemberCard,
			RewardList,
			RewardDetail,
      Flickity,

		},
		data(){
			return{
				is_load: false,
				error: '',
				data:{
					card: {},
					reward: []
				},
				reward_selected: '',
				slider_option:{
          category:{
            initialIndex: 0,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            contain: true,
            freeScroll: true,
            cellAlign: 'left'
          }
        },
        scrollPosition: null,
        category_id: 'all',
        category: [
	        {
	        	id: 'all',
	        	name: this.$t('hotel.concierge.fitur.all-reward')	
	        },
	        {
	        	id: 'concierge',
	        	name: this.$t('hotel.concierge.fitur.concierge')
	        },
	        {
	        	id: 'hotel',
	        	name: this.$t('hotel.concierge.fitur.hotel')
	        },
	        {
	        	id: 'other',
	        	name: this.$t('hotel.concierge.fitur.other')	
	        },
        ],
        detail: {
        	show: false,
        	name: '',
        	description: '',
        	type: '',
        	image_url: '',
        	url: '',
        	module: '',
        },
				detail_data: {},
        validation: {
        	room_dinning: "concierge-room-dining",
        	spa: "concierge-spa",
        	experience: "concierge-experience",
        	laundry: "concierge-laundry",
        }
			}
		},
		computed:{
			...mapGetters(['getMerchant','isNotLogin','getCurrentUser']),
			guest_name(){
				if(!this.isNotLogin){
					return this.getCurrentUser.first_name+' '+(this.getCurrentUser.last_name != null ? this.getCurrentUser.last_name : '')
				}else{
					return 'Guest Name'
				}
			}
		},
		mounted(){
			window.addEventListener("scroll", this.updateScroll);
			this.loadFirstData()
		},
		methods:{
			...mapMutations(['setMembershipRewardApplied']),
			loadMemberCard(){
				return new Promise((success,fail)=>{
	        get("CONCIERGE","membership/user-member-card-detail",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	        	let res = response.data
	         	if(res.success){
	         		success(res.data)
	         	}else{
	         		fail(res.message)
	         	}
	        })
				})
      },
      loadRewardList(){
				return new Promise((success,fail)=>{
	        get("CONCIERGE","membership/reward-list",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	          let res = response.data
	         	if(res.success){
	         		success(res.data)
	         	}else{
	         		fail(res.message)
	         	}
	        })
				})
      },
      loadFirstData(){
      	this.is_load = true
      	this.error = ''
      	Promise.all([this.loadMemberCard(),this.loadRewardList()])
      	.then(response=>{
      		this.data = {
      			card: response[0],
						reward: response[1]
      		}
      	})
      	.catch(err=>this.error = err)
      	.finally(()=>this.is_load = false)
      },
      backTo(){
				this.$emit('back')
			},
			parsingDataCard(data){
        let copied = JSON.parse(JSON.stringify(data))
        delete copied.benefit
        return copied
      },
      updateScroll() {
	      this.scrollPosition = window.scrollY;
	    },
	    closeDetail(){
	    	this.detail.show = !this.detail.show
	    },
	    detailReward(data, url){
	    	this.closeDetail()
	    	this.detail.name = data.name
	    	this.detail.type = data.type
	    	this.detail.description = data.description
	    	this.detail.image_url = data.image_url
	    	this.detail.module = data.module
				this.detail_data = data
	    },
	    routeReward(data){
				this.setMembershipRewardApplied(this.detail_data)
	    	this.$router.push(`/${this.getMerchant.code}/booking`)
	    },
	    moduleClaim(code){
				this.setMembershipRewardApplied(this.detail_data)
	    	if (code == this.validation.experience) {
	    		this.$router.push(`/${this.getMerchant.code}/concierge/experience`)
	    	}else if(code == this.validation.room_dinning){
	    		this.$router.push(`/${this.getMerchant.code}/concierge/room-dining`)
	    	}else if(code == this.validation.spa){
	    		this.$router.push(`/${this.getMerchant.code}/concierge/spa`)
	    	}else if(code == this.validation.laundry){
	    		this.$router.push(`/${this.getMerchant.code}/concierge/laundry`)
	    	}
	    },
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/general/account/Membership2.vue